module.exports = __webpack_public_path__ + "img/button_add.9dd48cbc.png";